import React from 'react';
import { Line } from 'react-chartjs-2';
import {
      Chart as ChartJS,
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend,
} from 'chart.js';

ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend,
);

export default function LineChart({Title, PointLabel, Data, Label, Value}) {
      const options = {
            responsive: true,
            plugins: {
                  legend: { position: 'bottom' },
                  title: {
                        display: true,
                        text: Title
                  }
            }
      };

      function generateData(initData) {
            let labels = [];
            let data = [];
            
            initData.map((d) => {
                  labels.push(d[Label]) // lable
                  data.push(d[Value]) // values
            })
            
            const _data = {
                  labels,
                  datasets: [
                        {
                              label: PointLabel,
                              data: data,
                              borderColor: '#F4C770',
                              backgroundColor: '#613F31',
                              // borderColor: '#613F31',
                              // backgroundColor: '#F4C770',
                              pointStyle: 'circle',
                              pointRadius: 5,
                              pointHoverRadius: 10
                        },
                  ],
            };

            return _data
      }

      return (
            <Line
                  data={generateData(Data)}
                  options={options}
            />
      )
}